export namespace ErrorSpec
{
    export function build<T>(specification: CaseSpecification<T>, messageArgs: any[] = []): T
    {
        const { errorType: error, message } = specification;
        if (!message)
            return new error();
        else if (typeof message === "string")
            return new error(message);
        else
            return new error(message(...messageArgs));
    }

    export interface CaseSpecification<T>
    {
        errorType: new (...args: any[]) => T;
        message?: ((...args: any[]) => string) | string;
    }

    export type Specification<E extends string | number> = Record<E, CaseSpecification<Error>>;
}
